import * as React from 'react';
import AntCollapse, {
    CollapseProps as AntCollapseProps,
} from 'antd/lib/collapse';
import { FontAwesomeIcon } from '../../FontAwesomeIcon';
import { faChevronUp } from '@fortawesome/pro-regular-svg-icons';
import './Collapse.less';
import Styles from './Collapse.module.less';

export type CollapseProps = Omit<
    AntCollapseProps,
    'ghost' | 'expandIconPosition' | 'bordered'
> & { children: React.ReactNode; iconClassName?: string };

export const Collapse = ({
    className,
    iconClassName,
    ...props
}: CollapseProps): JSX.Element => {
    return (
        <AntCollapse
            {...props}
            expandIconPosition="right"
            bordered={false}
            expandIcon={({ isActive }) => (
                <FontAwesomeIcon
                    className={iconClassName}
                    icon={faChevronUp}
                    rotation={isActive ? undefined : 180}
                />
            )}
            ghost
            className={className}
            prefixCls={Styles.collapse}
        />
    );
};

Collapse.Panel = AntCollapse.Panel;
